<dx-popup [title]="'remotePlatforms.lblHttpSite' | translate" [(visible)]="visible" (onShown)="onShown()" (onHidden)="onHidden()">
    <div *dxTemplate="let data of 'content'">
        <dx-progress-bar width="100%"
                         [height]="15"
                         [value]="false"
                         [visible]="isProgressBarVisible" />
        <dx-scroll-view>
            <dx-validation-group #remotePlatformValidation>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.information</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>remotePlatforms.lblDisabled</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="platform.isDisabled" [(readOnly)]="readOnly"></dx-switch>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblName<span class="dx-field-item-required-mark" *ngIf="!readOnly"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.name" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'remotePlatforms.msgNameRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblUrl<span class="dx-field-item-required-mark" *ngIf="!readOnly"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.url" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'remotePlatforms.msgUrlRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>remotePlatforms.lblHttpVerbForDeleting</div>
                        <div class="dx-field-value">
                            <app-http-verb-picker [(selectedItem)]="platform.httpVerbForDeleting" [(readonly)]="readOnly"></app-http-verb-picker>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>remotePlatforms.lblQueryStringForDeleting</div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.queryStringForDeleting" [(readOnly)]="readOnly"></dx-text-box>
                        </div>
                    </div>
                </div>
                <div class="dx-fieldset">
                    <div class="dx-fieldset-header" translate>_commons.security</div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblAccount<span class="dx-field-item-required-mark" *ngIf="!readOnly"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.account" [(readOnly)]="readOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="required" [message]="'remotePlatforms.msgAccountRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field" *ngIf="!readOnly">
                        <div class="dx-field-label" translate>
                            remotePlatforms.lblPassword<span class="dx-field-item-required-mark" *ngIf="!readOnly && !platform.id"> *</span>
                        </div>
                        <div class="dx-field-value">
                            <dx-text-box [(value)]="platform.password" mode="password" [placeholder]="getPasswordPlaceHolder()" [readOnly]="readOnly && !platform.id">
                                <dx-validator>
                                    <dxi-validation-rule type="custom" [reevaluate]="true" [validationCallback]="validateCredentials" [message]="'remotePlatforms.msgPasswordRequired' | translate"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label" translate>remotePlatforms.lblIpFiltering</div>
                        <div class="dx-field-value">
                            <dx-switch [(value)]="platform.ipFiltering" [(readOnly)]="readOnly"></dx-switch>
                        </div>
                    </div>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
        <div class="flex bottom-buttons leftButtons" *ngIf="!readOnly">
            <dx-button *ngIf="!readOnly" class="save leftButton" [text]="'_commons.save' | translate" (onClick)="save()"></dx-button>
            <dx-button class="cancel leftButton" [text]="'_commons.cancel' | translate" (onClick)="this.visible = false"></dx-button>
        </div>
        <div class="flex bottom-buttons" *ngIf="readOnly">
            <dx-button class="close closeButton" [text]="'_commons.close' | translate" (onClick)="this.visible = false"></dx-button>
        </div>
    </div>
</dx-popup>